import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	suggestDescriptionLabel: {
		id: 'company-hub.company-hub-common.link-cards.description.button.suggest-description.label',
		defaultMessage: 'Suggest Description',
		description: 'Text in the button to prompt user to generate a description for link using AI',
	},
});
